// src/components/Header.tsx
import React from "react";
import { Navbar, Container, Stack } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Helmet } from "react-helmet";
import spwLogo from "../images/SPWLogoTransparent.png";

const Header: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Singularity Pressure Washing</title>
        <meta
          name="description"
          content="A pressure washing service based in Santa Clarita, CA"
        />
      </Helmet>
      <Navbar
        data-bs-theme="light"
        bg="light"
        expand="md"
        collapseOnSelect={true}
        sticky="top"
        variant="light"
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
                <Stack direction="horizontal" gap={0}>
                    <img id="brand-logo" src={spwLogo} alt="Singularity Pressure Washing Logo"/>
                    <div className="d-none d-sm-block ms-1 font-karnivore-bold">Singularity Pressure Washing</div>
                    <div className="d-block d-sm-none ms-1 font-karnivore-bold">Singularity</div>
                </Stack>
            </Navbar.Brand>
          </LinkContainer>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
